import { useIntl } from 'react-intl';

import { useDispatch, useRequiredParams } from '_common/hooks';
import { navigateToTenantSettings } from 'router/navigation';
import { setMenuActiveOption } from '_common/components/Sidebar/SidebarSlice';

import { ActionBar } from '_common/components';
import { PathElement } from '_common/components/ActionBar/ActionBarBreadcrumb/ActionBarBreadcrumb';

type HeaderProps = { roleName: string };

const Header = ({ roleName }: HeaderProps) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { id: objectId } = useRequiredParams<RouterParams['roleSettings']>();

  const handleGoTo = (element: PathElement) => {
    dispatch(setMenuActiveOption({ menu: 'tenantSettings', activeOption: 'roles' }));
    navigateToTenantSettings();
  };

  return (
    <ActionBar>
      <ActionBar.Breadcrumb
        path={[
          {
            id: 'roles',
            name: intl.formatMessage({ id: 'settings.tenant.header' }),
          },
          {
            id: objectId,
            name: intl.formatMessage({ id: 'settings.roles.header' }, { role: roleName }),
          },
        ]}
        onBreadcrumbElementClick={handleGoTo}
        testId="role-settings-page"
      />
    </ActionBar>
  );
};

export default Header;
